<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'자료실'" class="sv2"></sub-visual>

        <div class="contents">
            <div class="container">
                <div class="board-container">
                    <board-list v-if="!_reference" v-bind="boardProps" :writeScope="['console']" />
                    <board-input v-else-if="isWrite" v-bind="boardProps" />
                    <board-view v-else v-bind="boardProps" :_id="_reference" />
                </div>
            </div>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BoardList from "@/components/client/board/board-list.vue";
import BoardInput from "@/components/client/board/board-input.vue";
import BoardView from "@/components/client/board/board-view.vue";

const boardProps = {
    code: "yknowledge-reference",
    skin: "board-reference",
};

export default {
    components: {
        ClientPage,
        SubVisual,
        BoardList,
        BoardInput,
        BoardView,
    },
    props: ["_reference"],
    computed: {
        isWrite() {
            return this._reference == "create";
        },
    },
    data() {
        return {
            boardProps,
        };
    },
};
</script>
